import type { BeneficialOwner } from '../types/formA.types';

/**
 * Creates an empty beneficial owner object with default values
 * @returns A new beneficial owner object with empty strings and undefined date
 */
export const createEmptyBeneficialOwner = (): BeneficialOwner => ({
  lastName: '',
  firstName: '',
  address: '',
  postcode: '',
  city: '',
  country: '',
  birthDate: undefined,
  nationality: '',
});

/**
 * Gets the default form values for Form A
 * @param defaultValues Optional partial default values to merge
 * @returns Complete default form values
 */
export const getFormADefaultValues = (
  defaultValues?: Partial<{
    beneficialOwnerType: string;
    beneficialOwners: BeneficialOwner[];
    originOfAssets: string[];
    originOfAssetsOther: string;
  }>
) => ({
  beneficialOwnerType: '',
  beneficialOwners: [],
  originOfAssets: [],
  originOfAssetsOther: '',
  ...defaultValues,
});

/**
 * Determines if beneficial owners section should be shown based on selected type
 * @param beneficialOwnerType The selected beneficial owner type
 * @returns True if beneficial owners section should be shown
 */
export const shouldShowBeneficialOwnersSection = (
  beneficialOwnerType: string
): boolean => {
  return beneficialOwnerType === 'others' || beneficialOwnerType === 'sole';
};

/**
 * Determines if "Other" text field should be shown for origin of assets
 * @param originOfAssets The selected origin of assets array
 * @returns True if "Other" field should be shown
 */
export const shouldShowOriginOfAssetsOther = (
  originOfAssets?: string[]
): boolean => {
  return originOfAssets?.includes('other') || false;
};
